module.exports = __webpack_public_path__ + "img/13-r.23cfbdcc.png";